import React from 'react';

export const BeGenuine = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="80" height="80" rx="40" fill="#BAE1D1" />
    <path
      d="M55.4017 23.9496C46.3822 20.0248 40.0006 29.582 40.0006 29.582C40.0006 29.582 33.6191 20.0248 24.5996 23.9432C17.5457 27.0143 14.9465 35.5839 18.7483 42.1976C21.6772 47.2947 27.6772 53.7172 38.9532 61.6688C39.26 61.8842 39.6272 62 40.0039 62C40.3805 62 40.7478 61.8842 41.0545 61.6688C52.324 53.7236 58.3241 47.2947 61.253 42.2039C65.0548 35.5903 62.4491 27.0207 55.4017 23.9496Z"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <rect
      x="47"
      y="36"
      width="14"
      height="14"
      rx="7"
      transform="rotate(90 47 36)"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);
